import { WorkshopProps } from '@/types';

export const workshopsData: WorkshopProps[] = [
  {
    // Card details
    typeOfEvent: 'workshop',
    language: 'en',
    cardTitle: 'this-youth-rising-title',
    buttonText: 'this-youth-rising',
    buttonLink: 'https://thisyouthrising.theraccoons.org/',
    cardImage: '/images/workshops/2026/ThisYouthRising.png',
    lastModified: '2026-08-23',
    show: true,
    date: new Date('2026-09-02T00:00:00'),
    // Page details
    slug: 'this-youth-rising',
    title: 'This Youth Rising',
    dateWithText: '2nd of September 2026',
    place: 'Online',
    eventShortDescription: 'This Youth Rising',
    image: {
      src: '/images/workshops/2026/ThisYouthRising.png',
      alt: 'This Youth Rising',
      width: 2000,
      height: 2715,
    },
    description: 'This Youth Rising',
    description2nd: '',
    when: '2nd of September 2026',
    where: 'Online',
    necessary: '',
    registerLink: 'https://thisyouthrising.theraccoons.org/',
    subInfoSection: [],
  },
  {
    // Card details
    typeOfEvent: 'workshop',
    language: 'en',
    cardTitle: 'info-stream-2024-title',
    buttonText: 'info-stream-2024',
    buttonLink: '/events/workshops/info-stream-2024',
    cardImage: '/images/workshops/2024/infostream-preview.png',
    lastModified: '2024-10-27',
    show: true,
    date: new Date('2024-11-14T18:00:00'),
    // Page details
    slug: 'info-stream-2024',
    title: 'info stream 2024',
    dateWithText: '14th of November 2024, 18:00-19:30',
    place: 'Online | Zoom',
    eventShortDescription:
      'Join our Zoom info session to learn about the rules and agenda, and how to make the most of the event!',
    image: {
      src: '/images/workshops/2024/infostream_fb_en.webp',
      alt: 'Info Stream 2024',
      width: 1188,
      height: 624,
    },
    description:
      'Is the hackathon starting soon, but you’re unsure about what to bring, how it will go, and what to expect?',
    description2nd:
      'Join us for a brief info session on Zoom to learn how we’ll fill these two days with excitement, new memories, and valuable skills! 💻',
    when: '14th of November, 18:00.',
    where: 'Online at link.theraccoons.org/info-stream',
    necessary: '',
    registerLink: 'https://link.theraccoons.org/info-stream',
    subInfoSection: [
      {
        shortDescription:
          "You do not need to fill out a form for the info stream. Just click the 'Sign up' button to watch the stream live or its recording later.",
      },
      { shortDescription: 'In case of any questions, email hello@theraccoons.org' },
    ],
  },
  {
    // Card details
    typeOfEvent: 'workshop',
    language: 'en',
    cardTitle: 'code-camp-10-title',
    buttonText: 'code-camp-10',
    buttonLink: '/events/workshops/code-camp-10',
    cardImage: '/images/workshops/2024/code-camp-10-preview.webp',
    lastModified: '2024-10-27',
    show: true,
    date: new Date('2024-11-11T17:00:00'),
    // Page details
    slug: 'code-camp-10',
    title: 'code camp 10',
    dateWithText: '11th of November 2024, 17:00-19:00',
    place: 'SEB Innovation Centre | Krišjāņa Barona Street 20, Riga',
    eventShortDescription:
      'Sensors are not scary! Join our hands-on Arduino workshop and learn the basics of sensor design.',
    image: {
      src: '/images/workshops/2024/code-camp-10.webp',
      alt: 'Code Camp 10',
      width: 1188,
      height: 624,
    },
    description:
      "Have you ever wanted to create your own sensor from scratch but didn't know which tools to use or where to start? 🔧 Join our hands-on workshop, where we'll guide you step by step through the entire process! \
      Learn about the tools you'll need—not just to build a working sensor now, but also to help you with prototyping in the future. 🚀",
    description2nd:
      'We especially welcome high school and university students with an interest in developing new ideas. Nevertheless, participation is free for everyone. You do not have to apply for the hackathon to attend.',
    when: '11th of November, 17:00.',
    where: 'SEB Innovation Centre | Krišjāņa Barona Street 20, Riga',
    necessary: 'Laptop, charger, and eagerness to learn.',
    registerLink: 'https://link.theraccoons.org/ws-apply',
    whatToExpect: 'What to expect from the workshop?',
    timeFrames: [
      {
        timeFrame: '17:00-17:20',
        descriptionOfTimeFrame: [
          {
            shortDescription: 'Get to know what is a microcontroller and why use Arduino;',
          },
        ],
      },
      {
        timeFrame: '17:20-19:00',
        descriptionOfTimeFrame: [
          {
            shortDescription: 'Capturing sensor data for your needs.',
          },
        ],
      },
    ],
    subInfoSection: [
      {
        shortDescription:
          'Snacks and drinks will be provided during the event. The workshop is organized in English.',
      },
      { shortDescription: 'In case of any questions, email hello@theraccoons.org' },
    ],
  },
  {
    // Card details
    typeOfEvent: 'workshop',
    language: 'en',
    cardTitle: 'code-camp-9-title',
    buttonText: 'code-camp-9',
    buttonLink: '/events/workshops/code-camp-9',
    cardImage: '/images/workshops/2024/code-camp-9-preview.webp',
    lastModified: '2024-10-27',
    show: true,
    date: new Date('2024-11-08T17:00:00'),
    // Page details
    slug: 'code-camp-9',
    title: 'code camp 9',
    dateWithText: '8th of November 2024, 17:00-19:00',
    place: 'SEB Innovation Centre | Krišjāņa Barona Street 20, Riga',
    eventShortDescription:
      'Learn how to turn ideas into prototypes in Figma, from beginner to pro through a step-by-step tutorial and useful tips!',
    image: {
      src: '/images/workshops/2024/code-camp-9-figma_fb_en.webp',
      alt: 'Code Camp 9',
      width: 1188,
      height: 624,
    },
    description:
      "Want to get ready for the hackathon and learn useful skills that you'll be able to use throughout the hackathon process? \
      Join our workshop where we'll focus on learning how to go from an idea to a real prototype in Figma. No prior experience is needed!",
    description2nd:
      'We especially welcome high school and university students with an interest in developing new ideas. Nevertheless, participation is free for everyone. You do not have to apply for the hackathon to attend.',
    when: '8th of November, 17:00.',
    where: 'SEB Innovation Centre | Krišjāņa Barona Street 20, Riga',
    necessary: 'Laptop, charger, and eagerness to learn.',
    registerLink: 'https://link.theraccoons.org/ws-apply',
    whatToExpect: 'What to expect from the workshop?',
    timeFrames: [
      {
        timeFrame: '17:00-17:20',
        descriptionOfTimeFrame: [
          {
            shortDescription: 'Intro to Figma tool and its applications;',
          },
        ],
      },
      {
        timeFrame: '17:20-19:00',
        descriptionOfTimeFrame: [
          {
            shortDescription: 'Designing and prototyping in Figma;',
          },
        ],
      },
    ],
    subInfoSection: [
      {
        shortDescription:
          'Snacks and drinks will be provided during the event. The workshop is organized in English.',
      },
      { shortDescription: 'In case of any questions, email hello@theraccoons.org' },
    ],
  },
  {
    // Card details
    typeOfEvent: 'workshop',
    language: 'en',
    cardTitle: 'from-idea-to-business-title',
    buttonText: 'from-idea-to-business',
    buttonLink: '/events/workshops/from-idea-to-business',
    cardImage: '/images/workshops/2024/from-idea-to-business-preview.webp',
    lastModified: '2024-10-27',
    show: true,
    date: new Date('2024-11-06T17:00:00'),
    // Page details
    slug: 'from-idea-to-business',
    title: 'from idea to business',
    dateWithText: '6th of November 2024, 17:00-19:00',
    place: 'SEB Innovation Centre | Krišjāņa Barona Street 20, Riga',
    eventShortDescription:
      'Join our workshop to hear and discuss key challenges in business and how to build one from scratch!',
    image: {
      src: '/images/workshops/2024/Workshop_Business_fb_en.webp',
      alt: 'Workshop: From Idea to Business',
      width: 1188,
      height: 624,
    },
    description:
      'Does the ideation seem like a struggle for you during the hackathon? Or, are you curious about turning your idea into a business concept? 💡\
      Join our workshop to learn and discuss how to take your concept from a dream to a successful venture. This time: less code - more discussion! 💬',
    description2nd:
      'We especially welcome high school and university students with an interest in developing new ideas. Nevertheless, participation is free for everyone. You do not have to apply for the hackathon to attend.',
    when: '6th of November, 17:00.',
    where: 'SEB Innovation Centre | Krišjāņa Barona Street 20, Riga',
    necessary: 'Laptop, charger, and eagerness to learn.',
    registerLink: 'https://link.theraccoons.org/ws-apply',
    subInfoSection: [
      {
        shortDescription:
          'Snacks and drinks will be provided during the event. Workshops are organized in English.',
      },
      { shortDescription: 'In case of any questions, email hello@theraccoons.org' },
    ],
  },
  {
    // Card details
    typeOfEvent: 'workshop',
    language: 'en',
    cardTitle: 'code-camp-8-title',
    buttonText: 'code-camp-8',
    buttonLink: '/events/workshops/code-camp-8',
    cardImage: '/images/workshops/2024/code-camp-8-preview.webp',
    lastModified: '2024-10-17',
    show: true,
    date: new Date('2024-10-25T17:00:00'),
    // Page details
    slug: 'code-camp-8',
    title: 'code camp 8',
    dateWithText: '25th of October 2024, 17:00-19:00',
    place: 'SEB Innovation Centre | Krišjāņa Barona Street 20, Riga',
    eventShortDescription:
      'Join us for an exciting workshop showcasing AI tools to bring your ideas to life!',
    image: {
      src: '/images/workshops/2024/code-camp-8_fb_en.webp',
      alt: 'Code Camp 8',
      width: 1188,
      height: 624,
    },
    description:
      'Are you curious about how to quickly build your own AI tool to simplify your everyday life or make a winning hackathon solution? 🚀\
      You will have an opportunity to build your own AI chatbot through a step-by-step tutorial. No prior knowledge or coding experience is required.💡✨',
    description2nd:
      'We especially welcome high school and university students with an interest in developing new ideas. Nevertheless, participation is free for everyone. You do not have to apply for the hackathon to attend.',
    when: '25th of October, 17:00.',
    where: 'SEB Innovation Centre | Krišjāņa Barona Street 20, Riga',
    necessary: 'Laptop, charger, and eagerness to learn.',
    registerLink: 'https://link.theraccoons.org/cc8-apply',
    whatToExpect: 'What to expect from the workshop?',
    timeFrames: [
      {
        timeFrame: '17:00-17:20',
        descriptionOfTimeFrame: [
          {
            shortDescription: 'Intro to development of AI tools;',
          },
        ],
      },
      {
        timeFrame: '17:20-19:00',
        descriptionOfTimeFrame: [
          {
            shortDescription: 'Developing your own chatbot;',
          },
        ],
      },
    ],
    subInfoSection: [
      { shortDescription: 'Snacks and drinks will be provided during the event.' },
      { shortDescription: 'In case of any questions, email hello@theraccoons.org' },
    ],
  },
  {
    // Card details
    typeOfEvent: 'workshop',
    language: 'lv',
    cardTitle: 'code-camp-7-title',
    buttonText: 'code-camp-7',
    buttonLink: '/events/workshops/code-camp-7',
    cardImage: '/images/workshops/2024/code-camp-7-preview.webp',
    lastModified: '2024-04-26',
    show: true,
    date: new Date('2024-04-26T16:00:00'),
    // Page details
    slug: 'code-camp-7',
    title: 'code camp 7',
    dateWithText: '2024.gads 26.aprīlis 16:00-18:00',
    place: 'SEB Inovāciju centrs | Krišjāņa Barona iela, Rīga',
    eventShortDescription:
      'Nāc uz darbnīcu, un kopīgi izveidosim robotu Discord saziņas platformā, izmantojot programmēšanas valodu Python! 🐍',
    image: {
      src: '/images/workshops/2024/code-camp-7.webp',
      alt: 'Code Camp 7',
      width: 1188,
      height: 624,
    },
    description:
      'Pasākumā izzināsi, kas ir bots, kā automatizēt saziņu un citas populārajā Discord saziņas platformā esošās funkcijas. Izveidosi pats savu sarunu biedru - botu -, programmējot ar Python. Iepriekšēja pieredze darbā ar Python programmēšanas valodu un Discord nav nepieciešama, tāpēc ņem vērā, ka uz darbnīcu sevišķi aicināti tie, kas vēlas pamēģināt ko jaunu.',
    moreInfo: 'Vairāk par Python: ',
    moreInfoLink: 'https://www.python.org/',
    description2nd:
      'Īpaši aicināti uz pasākumu ir vidusskolas skolēni un universitātes studenti, ar interesti par tehnoloģijām vai jaunu ideju veidošanu. Jebkuram dalībniekam pasākums ir par brīvu.',
    when: '26.aprīlis 16:00.',
    where: 'SEB Inovāciju centrs, Krišjāņa Barona iela 20, Rīga',
    necessary: 'Dators, lādētājs un vēlme apgūt jaunas tehnoloģijas!',
    registerLink: 'https://forms.gle/ASzvBJX22mYvMdUAA',
    whatToExpect: 'Ko vari sagaidīt no darbnīcas?',
    slidesLink: 'https://link.theraccoons.org/cc-discord',
    timeFrames: [
      {
        timeFrame: '16:00-16:20',
        descriptionOfTimeFrame: [
          {
            shortDescription: 'Iepazīšanās un apskats par Python un Discord;',
          },
        ],
      },
      {
        timeFrame: '16:20-17:50',
        descriptionOfTimeFrame: [
          {
            shortDescription: 'Discord bota veidošana;',
          },
        ],
      },
    ],
    subInfoSection: [
      { shortDescription: 'Pasākuma laikā un pēc pasākuma tiks nodrošināti dzērieni un uzkodas.' },
      { shortDescription: 'Jautājumu gadījumā droši zvani/raksti: +371 26115374' },
    ],
  },
  {
    // Card details
    typeOfEvent: 'workshop',
    language: 'lv',
    cardTitle: 'code-camp-6-title',
    buttonText: 'code-camp-6',
    buttonLink: '/events/workshops/code-camp-6',
    cardImage: '/images/workshops/2024/code-camp-6-preview.webp',
    lastModified: '2024-04-05',
    show: true,
    date: new Date('2024-03-22T16:00:00'),
    // Page details
    slug: 'code-camp-6',
    title: 'code camp 6',
    dateWithText: '2024.gads 22.marts 16:00-18:00',
    place: 'SEB Inovāciju centrs | Krišjāņa Barona iela, Rīga',
    eventShortDescription:
      'Pievienojies darbnīcai un izmēģini vienu no populārākajiem mājaslapu programmēšanas rīkiem pasaulē - React.',
    image: {
      src: '/images/workshops/2024/code-camp-6.webp',
      alt: 'Code Camp 6',
      width: 1188,
      height: 624,
    },
    description:
      'Darbnīcā uzzināsi vairāk par to, kas ir JavaScript bibliotēkas, un kopā praktiski izpētīsim visbiežāk izmantoto no tām - React. Varēsi izveidot pats savu (varbūt pirmo?!) mājaslapu, izmantojot mūsdienīgas izstrādes tehnoloģijas un paņēmienus. Nekādas iepriekšējas zināšanas par JavaScript vai React nav nepieciešamas, tāpēc ņem vērā, ka darbnīca paredzēta tiem, kas vēlas pamēģināt vēl nepieredzētu mājaslapu izstrādes veidu.',
    moreInfo: 'Vairāk par React: ',
    moreInfoLink: 'https://react.dev/',
    description2nd:
      'Īpaši aicināti uz pasākumu ir vidusskolas skolēni un universitātes studenti, ar interesti par tehnoloģijām vai jaunu ideju veidošanu. Jebkuram dalībniekam pasākums ir par brīvu.',
    when: '22.marts 16:00',
    where: 'SEB Inovāciju centrs, Krišjāņa Barona iela 20, Rīga',
    necessary: 'Dators, lādētājs un vēlme apgūt jaunas tehnoloģijas!',
    registerLink: 'https://forms.gle/m43ETZfxYfWder12A',
    whatToExpect: 'Ko vari sagaidīt no darbnīcas?',
    timeFrames: [
      {
        timeFrame: '16:00-16:25',
        descriptionOfTimeFrame: [
          {
            shortDescription:
              'Iepazīšanās un apskats par JavaScript un kas ir JavaScript bibliotēkas;',
          },
        ],
      },
      {
        timeFrame: '16:25-17:50',
        descriptionOfTimeFrame: [
          {
            shortDescription:
              'Iepazīšanās ar React un praktiska darbošanās izmantojot React lai uzbūvētu savu pirmo mājaslapu;',
          },
        ],
      },
    ],
    subInfoSection: [
      { shortDescription: 'Pasākuma laikā un pēc pasākuma tiks nodrošināti dzērieni un uzkodas.' },
      { shortDescription: 'Jautājumu gadījumā droši zvani/raksti: +371 26115374' },
    ],
  },
  {
    // Card details
    typeOfEvent: 'workshop',
    language: 'lv',
    cardTitle: 'code-camp-5-title',
    buttonText: 'code-camp-5',
    buttonLink: '/events/workshops/code-camp-5',
    cardImage: '/images/workshops/2024/code-camp-5-preview.webp',
    lastModified: '2024-03-11',
    show: true,
    date: new Date('2024-02-23T16:00:00'),
    // Page details
    slug: 'code-camp-5',
    title: 'code camp 5',
    dateWithText: '2024.gads 23.februāris 16:00-18:00',
    place: 'SEB Inovāciju centrs | Krišjāņa Barona iela, Rīga',
    eventShortDescription:
      'Pievienojies darbnīcai un uzzini kādi ir biežākie rīki un tehnoloģijas, kas tiek pielietotas spēļu izstrādes veidošanā, kā arī izmēģini izveidot savu spēli. ',
    image: {
      src: '/images/workshops/2024/code-camp-5.webp',
      alt: 'Code Camp 5',
      width: 594,
      height: 312,
    },
    description:
      'Pasākuma laikā praktiski darbosimies, apgūstot pamatus par spēļu izstrādi. Iepazīsimies ar vairākiem populāriem rīkiem, ko izmanto spēļu izstrādē un mēģināsim izveidot arī savu pirmo spēli. Nekādas iepriekšējas zināšanas nav nepieciešamas, tamdēļ jāņem vērā, ka darbnīca paredzēta iesācējiem un tiem, kas nav vēl nekad izstrādājuši savas spēles.',
    description2nd:
      'Īpaši aicināti uz pasākumu ir vidusskolas skolēni un universitātes studenti, ar interesti par tehnoloģijām vai jaunu ideju veidošanu. Jebkuram dalībniekam pasākums ir par brīvu.',
    when: '23.februāris 16:00',
    where: 'SEB Inovāciju centrs, Krišjāņa Barona iela 20, Rīga',
    necessary: 'Dators, lādētājs un vēlme apgūt jaunas tehnoloģijas!',
    registerLink: 'https://forms.gle/EtpjgKqbrvyQyQ4M9',
    whatToExpect: 'Ko vari sagaidīt no darbnīcas?',
    timeFrames: [
      {
        timeFrame: '16:00-16:25',
        descriptionOfTimeFrame: [
          { shortDescription: 'Iepazīšanās un apskats par spēļu izstrādes rīkiem un tendencēm;' },
        ],
      },
      {
        timeFrame: '16:25-17:50',
        descriptionOfTimeFrame: [{ shortDescription: 'Praktiska darbošanās veidojot spēles;' }],
      },
    ],
    subInfoSection: [
      { shortDescription: 'Pasākuma laikā un pēc pasākuma tiks nodrošināti dzērieni un uzkodas.' },
      { shortDescription: 'Jautājumu gadījumā droši zvani/raksti: +371 26115374' },
    ],
  },
  {
    // Card details
    typeOfEvent: 'workshop',
    language: 'lv',
    cardTitle: 'code-camp-4-title',
    buttonText: 'code-camp-4',
    buttonLink: '/events/workshops/code-camp-4',
    cardImage: '/images/workshops/2024/code-camp-4-preview.webp',
    lastModified: '2024-03-11',
    show: true,
    date: new Date('2024-01-26T16:00:00'),
    // Page details
    slug: 'code-camp-4',
    title: 'code camp 4',
    dateWithText: '2024. gads 26. janvāris 16:00-18:00',
    place: 'SEB Inovāciju centrs | Krišjāņa Barona iela, Rīga',
    eventShortDescription:
      'Pievienojies darbnīcai un uzzini, kā uzbūvēt savu mobilo lietotni, izmantojot rīku Flutter. ',
    image: {
      src: '/images/workshops/2024/code-camp-4.webp',
      alt: 'Code Camp 4',
      width: 950,
      height: 499,
    },
    description:
      'Pasākuma laikā praktiski darbosimies, apgūstot pamatus par mobilajām lietotnēm un kam jāpievērš uzmanība, tās izstrādājot. Kā arī pievērsīsimies plaši izmantotajam rīkam Flutter, apskatīsim vairākas tā iespējas un iemācīsimies viņu pielietot lietotņu veidošanā. Nekādas iepriekšējas zināšanas par lietotņu veidošanu un Flutter no dalībniekiem netiek sagaidītas.',
    moreInfo: 'Vairāk par rīku Flutter: ',
    moreInfoLink: 'https://flutter.dev/',
    description2nd:
      'Īpaši aicināti uz pasākumu ir vidusskolas skolēni un universitātes studenti, ar interesti par tehnoloģijām vai jaunu ideju veidošanu. Jebkuram dalībniekam pasākums ir par brīvu.',
    when: '26.janvāris 16:00',
    where: 'SEB Inovāciju centrs, Krišjāņa Barona iela 20, Rīga',
    necessary: 'Dators, lādētājs un vēlme apgūt jaunas tehnoloģijas!',
    registerLink: 'https://forms.gle/Ez8RGvp3Uu1dkHdX8',
    whatToExpect: 'Ko vari sagaidīt no darbnīcas?',
    timeFrames: [
      {
        timeFrame: '16:00-16:25',
        descriptionOfTimeFrame: [
          { shortDescription: 'Iepazīšanās un apskats par lietotnēm;' },
          {
            shortDescription:
              'Izpratne par dažādām lietotnēm un funkcijām, kas jāņem vērā, tās veidojot; ',
          },
        ],
      },
      {
        timeFrame: '16:25-17:50',
        descriptionOfTimeFrame: [
          { shortDescription: 'Apskats par Flutter un tā iespējām;' },
          { shortDescription: 'Mobilās lietotnes veidošana ar Flutter;' },
        ],
      },
    ],
    subInfoSection: [
      { shortDescription: 'Pasākuma laikā un pēc pasākuma tiks nodrošināti dzērieni un uzkodas.' },
      { shortDescription: 'Jautājumu gadījumā droši zvani/raksti: +371 26115374' },
    ],
  },
  {
    // Card details
    typeOfEvent: 'workshop',
    language: 'lv',
    cardTitle: 'code-camp-3-title',
    buttonText: 'code-camp-3',
    buttonLink: '/events/workshops/code-camp-3',
    cardImage: '/images/workshops/2023/code-camp-3-preview.webp',
    lastModified: '2024-03-11',
    show: true,
    date: new Date('2023-12-15T16:00:00'),
    // Page details
    slug: 'code-camp-3',
    title: 'code camp 3',
    dateWithText: '2023. gads 15. decembris 16:00-18:00',
    place: 'SEB Inovāciju centrs | Krišjāņa Barona iela, Rīga',
    eventShortDescription:
      'Pievienojies darbnīcai un uzzini kā labāk nonākt līdz savai biznesa idejai un uzbūvēt pirmo mājaslapas prototipu.',
    image: {
      src: '/images/workshops/2023/code-camp-3.webp',
      alt: 'Code Camp 3',
      width: 950,
      height: 499,
    },
    description:
      'Pasākuma laikā apgūsi praktiskus ieteikumus, kas nākotnē palīdzēs attīstīt jaunu biznesa ideju, izprast kā nonākt līdz jaunam produktam un izvērtēt savas idejas ilgtspējību. Otrajā darbnīcas daļā iemācīsies, kā veidot mājaslapu savai idejai ar pieejamajiem no-code rīkiem. Nekādas iepriekšējas zināšanas nav nepieciešamas un pasākums paredzēts tiem, kuriem nav/ir minimāla pieredze ar no-code rīkiem un uzņēmējdarbību.',
    moreInfo: '',
    description2nd:
      'Īpaši aicināti uz pasākumu ir vidusskolas skolēni un universitātes studenti, ar interesti par tehnoloģijām vai jaunu ideju veidošanu. Jebkuram dalībniekam pasākums ir par brīvu.',
    when: '15.decembris 16:00',
    where: 'SEB Inovāciju centrs, Krišjāņa Barona iela 20, Rīga',
    necessary: 'Dators, lādētājs un vēlme apgūt jaunas tehnoloģijas!',
    registerLink: 'https://bit.ly/raccoons_cc3',
    whatToExpect: 'Ko vari sagaidīt no darbnīcas?',
    timeFrames: [
      {
        timeFrame: '16:00-16:45',
        descriptionOfTimeFrame: [
          {
            shortDescription:
              'Attīsti radošo domāšanu ideju ģenerēšanas procesā un iemācies kā izvērtēt idejas dzīvotspēju;',
          },
          { shortDescription: 'Iegūsti izpratni par biznesa modeļiem un tirgus tendencēm;' },
          {
            shortDescription:
              'Sadarbojies ar citiem dalībniekiem un kopīgi izvērtē savas biznesa idejas ilgtspējību.',
          },
        ],
      },
      {
        timeFrame: '16:55-17:50',
        descriptionOfTimeFrame: [
          { shortDescription: 'Iedziļinies mājaslapu izstrādes un lietotāja pieredzes pamatos;' },
          { shortDescription: 'Izmantojot no-code rīkus izveido savu pirmo mājaslapas prototipu;' },
          { shortDescription: 'Izproti labāk lietotāja nozīmi savas idejas prototipa veidošanā.' },
        ],
      },
    ],
    subInfoSection: [
      { shortDescription: 'Pasākuma laikā un pēc pasākuma tiks nodrošināti dzērieni un uzkodas.' },
      { shortDescription: 'Jautājumu gadījumā droši zvani/raksti: +371 26115374' },
    ],
  },
  {
    // Card details
    typeOfEvent: 'workshop',
    language: 'en',
    cardTitle: 'code-camp-2-title',
    buttonText: 'code-camp-2',
    buttonLink: '/events/workshops/code-camp-2',
    cardImage: '/images/workshops/2023/code-camp-2-preview.webp',
    lastModified: '2024-03-11',
    show: true,
    date: new Date('2023-10-04T18:00:00'),
    // Page details
    slug: 'code-camp-2',
    title: 'code camp 2',
    dateWithText: 'October 4, 2023, 18:00',
    place: 'SEB Inovation center | Krišjāņa Barona street 20, Rīga',
    eventShortDescription: 'PART 2 to our first CODE CAMP!',
    image: {
      src: '/images/workshops/2023/code-camp-2.webp',
      alt: 'Code Camp 2',
      width: 3000,
      height: 1809,
    },
    description:
      'If you are new to coding, this in-person session is going to help you familiarize yourself with coding projects and GitHub. Learn to navigate your repo, understand branches, and collaborate with others on code.',
    moreInfo: '',
    description2nd: '',
    when: '',
    where: '',
    necessary: '',
    registerLink: '',
    subInfoSection: [],
  },
  {
    // Card details
    typeOfEvent: 'workshop',
    language: 'en',
    cardTitle: 'code-camp-1-title',
    buttonText: 'code-camp-1',
    buttonLink: '/events/workshops/code-camp-1',
    cardImage: '/images/workshops/2023/code-camp-1-preview.webp',
    lastModified: '2024-03-11',
    show: true,
    date: new Date('2023-09-20T18:00:00'),
    // Page details
    slug: 'code-camp-1',
    title: 'code camp 1',
    dateWithText: 'September 20, 2023, 18:00',
    place: 'SEB Inovation center | Krišjāņa Barona street 20, Rīga',
    eventShortDescription:
      'Join the workshop and familiarize yourself with the coding environment and basic front-end web design!',
    image: {
      src: '/images/workshops/2023/code-camp-1.webp',
      alt: 'Code Camp 1',
      width: 3000,
      height: 1809,
    },
    description:
      'Do you want to introduce yourself to coding and build a simple site? This in-person session is going to help you familiarize yourself with a coding environment and basic front-end web design in a hands-on workshop!',
    moreInfo: '',
    description2nd: '',
    when: '',
    where: '',
    necessary: '',
    registerLink: '',
    subInfoSection: [],
  },
];
